import { LuShield, LuUserX, LuZap } from 'react-icons/lu';
import styles from '../styles.module.scss';

const BADGES = [
    { Icon: LuShield, text: '完全無料' },
    { Icon: LuUserX, text: '匿名OK' },
    { Icon: LuZap, text: '約1分で完了' },
];

export const HeroSection = () => {
    return (
        <section className={styles.heroSection}>
            <div className={styles.heroLeft}>
                <h2 className={styles.heroTitle}>
                    物件の価格、
                    <br />
                    気軽に調べてみよう
                </h2>
                <p className={styles.heroDesc}>
                    無料・匿名で、たった1分。
                    <br />
                    しつこい営業の心配はありません。
                    <br />
                    まずはざっくりとした相場を知ることから始めましょう。
                </p>
                <div className={styles.heroBadges}>
                    {BADGES.map((badge) => {
                        const Icon = badge.Icon;
                        return (
                            <span key={badge.text} className={styles.heroBadge}>
                                <span className={styles.heroBadgeIcon}>
                                    <Icon size={14} color="currentColor" />
                                </span>
                                {badge.text}
                            </span>
                        );
                    })}
                </div>
            </div>
            <div className={styles.heroRight}>
                <div className={styles.heroImage} />
            </div>
        </section>
    );
};
